import distanceInWordsStrict from 'date-fns/distance_in_words_strict'
export const globalfunc = {
  timeSince: (date) => {
    let secFormat = distanceInWordsStrict(new Date(), date, {unit: 's'})
    let seconds = parseInt(secFormat.replace(/ seconds/g, ""))
    var intervalType;

    var interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      intervalType = 'year';
    } else {
      interval = Math.floor(seconds / 2592000);
      if (interval >= 1) {
        intervalType = 'month';
      } else {
        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
          intervalType = 'day';
        } else {
          interval = Math.floor(seconds / 3600);
          if (interval >= 1) {
            intervalType = "hour";
          } else {
            interval = Math.floor(seconds / 60);
            if (interval >= 1) {
              intervalType = "min";
            } else {
              interval = seconds;
              intervalType = "second";
            }
          }
        }
      }
    }

    if (interval > 1 || interval === 0) {
      intervalType += 's';
    }

    return interval + ' ' + intervalType + ' ago';
  },
  getTeamOfParent: (parent, teams) => {
    for (const i in parent) {
      teams[parent[i]["team_id"]] = true;
      if (parent[i]["parent"]) {
        teams = globalfunc.getTeamOfParent(parent[i]["parent"], teams);
      }
    }
    return teams;
  },
  generateToken: (length) => {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    return result;
  },
  round: (value, decimals) => {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
  },
  ordinal_suffix_of: (i) => {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
  },
  getAllParent: (teams, key) => {
    const organization = [];
    for(let x in teams[key]){
      
      if(teams[teams[key][x].team_id] !== undefined){
        organization.push({team_id: teams[key][x].team_id, parent: globalfunc.getAllParent(teams, teams[key][x].team_id)});
      }else{
        organization.push({team_id: teams[key][x].team_id});
      }
    }
    return organization;
  },
  generateRandomNumber() {
    const min = 1;
    const max = 999999999;
  
    let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    let formattedNumber = randomNumber.toFixed(0).padStart(9, '0');
  
    return formattedNumber;
  },
  truncateText: (text, maxLength) => {
    let length = maxLength;
    return text.length > length ? text.slice(0, length) + "..." : text;
  },
  addCommasInNumber: (value, decimal) => {
    let num = Number(value).toFixed(decimal);
    let str = num.toString().split(".");
    if (str[0].length >= 4) {
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    }
    return `${str[0]}.${str[1]}`;
  },
  calculateStartDate: (year,month,startDay) => {
    let cycleStart = new Date(`${year}-${month}-${startDay}`);
    cycleStart.setMonth(cycleStart.getMonth() - 1);
    cycleStart.setDate(cycleStart.getDate() + 1);
    return cycleStart;
  },
  // calculateEndDate: (startDay) => {
  //   const today = new Date();
  //   let cycleStart = new Date(today.getFullYear(), today.getMonth(), startDay);
  //   if (today.getDate() < startDay) {
  //     cycleStart.setMonth(cycleStart.getMonth() - 1);
  //   }
  //   cycleStart.setMonth(cycleStart.getMonth() + 1);
  //   cycleStart.setDate(cycleStart.getDate() - 1);
  //   return cycleStart;
  // }
  calculatePercentile: (arr, percentile) => {
    // Sort array in ascending order
    const sorted = arr.filter(val => val !== null && val !== undefined && !isNaN(val)).sort((a, b) => a - b);
    
    if (sorted.length === 0) return 0;
    if (sorted.length === 1) return sorted[0];
    
    // Calculate the index for the percentile
    const index = (percentile / 100) * (sorted.length - 1);
    const lower = Math.floor(index);
    const upper = Math.ceil(index);
    const weight = index % 1;
    
    // If the index is an integer, return the value at that index
    if (lower === upper) {
      return sorted[index];
    }
    
    // Otherwise, interpolate between the two nearest values
    return sorted[lower] * (1 - weight) + sorted[upper] * weight;
  },
  /**
   * Unified Culture Index score calculation that dispatches to the correct
   * method based on question type (Scale 0-10 vs Multiple Choice with feelings).
   * Returns {dataSum, total} so that (dataSum/total)*100 = 0-100 score.
   */
  calculateCultureScore: function(questionMasterArr, questId, answers) {
    const questionData = questionMasterArr ? questionMasterArr[questId] : null;
    const isScale = questionData && questionData.type === 'Scale';
    if (isScale) {
      return this.calculateScaleScore(answers);
    }
    return this.calculateFeelingScore(questionMasterArr, questId, answers);
  },
  getCultureOptionScore: function(questionData, answerIndex) {
    const mChoice = questionData && questionData.m_choice ? questionData.m_choice : {};
    const feelings = Array.isArray(mChoice.feeling) ? mChoice.feeling : [];
    const cultureStrengthWeights = [1, 0.5, 0.25, 0, 0, 0];
    const optionCount = Math.max(
      Array.isArray(mChoice.en) ? mChoice.en.length : 0,
      feelings.length,
      Number(answerIndex) + 1
    );
    const feeling = feelings[answerIndex];

    if (optionCount <= 2 && feeling) {
      if (feeling === 'Positive') return 1;
      if (feeling === 'Neutral') return 0.5;
      return 0;
    }

    if (feeling === 'Positive') {
      const positiveIndexes = feelings
        .map((item, index) => item === 'Positive' ? index : -1)
        .filter(index => index >= 0);
      const positivePosition = positiveIndexes.indexOf(Number(answerIndex));

      if (positiveIndexes.length <= 1 || positivePosition <= 0) {
        return 1;
      }

      return 0.5;
    }

    if (feeling === 'Neutral') {
      return 0.25;
    }

    if (feeling === 'Negative') {
      return 0;
    }

    if (mChoice.weight && mChoice.weight[answerIndex] !== undefined) {
      const weight = Number(mChoice.weight[answerIndex]);
      if (!isNaN(weight)) {
        return weight > 1 ? weight / 100 : weight;
      }
    }

    if (optionCount >= 5 && cultureStrengthWeights[Number(answerIndex)] !== undefined) {
      return cultureStrengthWeights[Number(answerIndex)];
    }

    if (optionCount > 1) {
      return (optionCount - 1 - Number(answerIndex)) / (optionCount - 1);
    }

    return 0;
  },
  /**
   * Calculate Culture Index score for custom multiple-choice questions.
   * Positive/neutral/negative tags still define direction, but multiple
   * positive or negative options are graded so "Strongly Agree" outranks
   * "Agree" and "Disagree" outranks "Strongly Disagree".
   *
   * @param questionMasterArr - Master array containing question data with feeling info
   * @param questId - Question ID to look up
   * @param answers - Object with answer keys and their counts { answerKey: count }
   * @returns { dataSum: number, total: number } - Returns normalized dataSum and total for percentage calculation
   */
  calculateFeelingScore: function(questionMasterArr, questId, answers) {
    let dataSum = 0;
    let total = 0;
    const questionData = questionMasterArr ? questionMasterArr[questId] : null;
    
    for (const answer in answers) {
      if (answers.hasOwnProperty(answer)) {
        const count = Number(answers[answer]);
        if (!isNaN(count) && count > 0) {
          dataSum += count * this.getCultureOptionScore(questionData, Number(answer));
          total += count;
        }
      }
    }
    
    return { dataSum, total };
  },
  getCultureScaleScoreWeight: function(score) {
    if (score >= 9) return 1;
    if (score >= 7) return 0.5;
    if (score >= 4) return 0.25;
    return 0;
  },
  /**
   * Calculate score for Scale (0-10) questions used in Culture Index.
   * Scale bands follow the strict Culture weighting: 9-10 = 100,
   * 7-8 = 50, 4-6 = 25, 0-3 = 0.
   *
   * @param answers - Object with score keys (0-10) and their counts { "0": count, "1": count, ..., "10": count }
   * @returns { dataSum: number, total: number }
   */
  calculateScaleScore: function(answers) {
    let dataSum = 0;
    let total = 0;

    for (const key in answers) {
      if (answers.hasOwnProperty(key)) {
        const score = Number(key);
        const count = Number(answers[key]);
        if (!isNaN(score) && !isNaN(count) && count > 0) {
          dataSum += count * this.getCultureScaleScoreWeight(score);
          total += count;
        }
      }
    }

    return { dataSum, total };
  }
}
